import { Get, Remove, Set } from "../../../../../Request";

export const FormSubmit = async data => {
  await Set({
    url: "/region/store",
    data: data,
  });
};

export const GetData = async (pageNumber, city_id, limit = 15, page = null) => {
  return await Get({
    url: "/region/show_all",
    data: {
      limit: limit,
      city_id: city_id,
    },

    page: pageNumber,
  }).then(data => {
    return data;
  });
};

export const DeleteData = async data => {
  await Remove({
    url: "/region/destroy",
    data: data,
  });
};

export const getProvinces = async () => {
  return await Get({
    url: "/province/show",
    data: {},
  }).then(data => {
    return data;
  });
};

export const getCity = async id => {
  return await Get({
    url: "/city/show",
    data: { province_id: id },
  }).then(data => {
    return data;
  });
};
export const EditData = async data => {
  await Set({
    url: "/region/update",
    data: data,
  });
};
